import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, QueryList, Renderer2, TemplateRef, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantesConfiguracionCalendarioEnum } from '@appNeo/core/helpers/enums/constantesConfiguracionCalendarioEnum';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { IConfiguracionButtonCta } from '@appNeo/pages/fragmentos/main-header/main-header.component';
import { PAGINAS_ROUTES } from '@appNeo/pages/pages-routes-data';
import { environment } from '@environments/environment';
import { finalize } from 'rxjs';
import { ProximamenteDlgComponent } from '../../proximamente-dlg/proximamente-dlg.component';


@Component({
  selector: 'neo-menu-burger',
  templateUrl: './menu-burger.component.html',
  styleUrls: ['./menu-burger.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('visibilityChanged', [
      state('shown', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('shown => hidden', animate('200ms')),
      transition('hidden => shown', animate('200ms')),
    ])
  ]
})
export class MenuBurgerComponent implements OnInit, OnDestroy {
  @ViewChildren(ProximamenteDlgComponent) accionesDialogoProximamente: QueryList<ProximamenteDlgComponent>;
  @Input() style : string = 'color';
  @Input() elementos  = [];
  @Input() buttonCta: boolean;
  @Input() configuracionButtonCta: IConfiguracionButtonCta = { otroUso: false };


  @Input() menuUser;
  @Input() menuSocial;

  @Input() customProyeccion: TemplateRef<any>;

  visiblityState = 'hidden';

  accesoAltaReservasPublico: boolean = environment.proximamente_reservas;
  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private preferenciasService: PreferenciasService,
    private auxiliarService: AuxiliarService
  ) { }

  ngOnInit(): void {
    this.cargarAccesoAltaReservasPublico();
  }

  ngAfterViewInit() {
    if (this.buttonCta && this.configuracionButtonCta.otroUso) {
      if ((!this.configuracionButtonCta?.url && !this.configuracionButtonCta?.path)
        || !this.configuracionButtonCta?.label
      ) {
        throw new Error("[ERROR DE CONFIGURACION COMPONENTE NEO ][MENU-BURGER] Configurado de forma incorrecta el mainCta para otroUso");
      }
    }
  }

  cargarAccesoAltaReservasPublico() {
    this.preferenciasService.getApi(ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico).subscribe(
      x => this.accesoAltaReservasPublico = this.auxiliarService.getBoolean(x.valor),
      e => this.accesoAltaReservasPublico = this.auxiliarService.getBoolean(this.preferenciasService.get(ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico))
    );
  }

  accederAreaCliente() {
    this.preferenciasService.getApi(ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico)
      .pipe(
        finalize(() => {
          if (this.accesoAltaReservasPublico) {
            this.router.navigate(['/areaCliente/informacion-reserva']);
          } else {
            this.mostrarProximamente();
          }
        })
      )
      .subscribe(
        x => this.accesoAltaReservasPublico = this.auxiliarService.getBoolean(x.valor),
        e => this.accesoAltaReservasPublico = this.auxiliarService.getBoolean(this.preferenciasService.get(ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico))
      );
  }

  mostrarProximamente() {
    this.ocultar();
    this.accionesDialogoProximamente.first.abrirDialogo();
  }

  menuBurgerToggle() {
    // $('html').toggleClass('menuBurger-on');
    // $('.menuBurger-cont').fadeToggle(200);
    
    if (this.visiblityState === 'hidden') {
      // this.renderer.addClass(this.document.body, 'menuBurger-on');
      this.renderer.addClass(document.documentElement, 'menuBurger-on');
      this.visiblityState = 'shown';
    } else {
      this.ocultar();
    }
  }

  ocultar() {
    const html = this.renderer;
    this.visiblityState = 'hidden';
    setTimeout(function(){
      // this.renderer.removeClass(this.document.body, 'menuBurger-on');
      html.removeClass(document.documentElement, 'menuBurger-on');
    }, 200);
  }
  seleccionItemMenu(menuItem){
    console.log(menuItem);
    if (menuItem.urlExterna) {
      if (menuItem?.url && menuItem?.url!='#') {
        window.location.href = menuItem?.url;
        this.ocultar();
      }
    } else {
      // menuItem.path = (menuItem?.pageRouter && PAGINAS_ROUTES[menuItem.pageRouter]) ? PAGINAS_ROUTES[menuItem.pageRouter] : menuItem.path;
      if (menuItem?.path && menuItem.path.length) {
        this.router.navigate([menuItem.path]);
        this.ocultar();
      }
    }
    
  }

  ngOnDestroy(): void {
    this.ocultar();
  }

}
